import React from "react";
import { Redirect } from "react-router-dom";
import PublicHome from "../../core/PublicHome/PublicHome";
import "./Logout.scss";

const Logout = (props: any) => {
    // props.authProps.clearAuthentication(true);
    window.location.href = `${process.env.REACT_APP_LOGINURL}/logout`;
    return <PublicHome />
    // return <Redirect to={`${process.env.REACT_APP_LOGINURL}/logout`} push={true}></Redirect>;    
  };

export default Logout;
